<template>
  <div :class="['wrapper', orderType ? 'space-between' : '']">
    <div v-if="orderType" class="score">
<!--      <div
        class="item"
        v-if="orderScoreProfile.sysHitGrade"
        :style="{
          backgroundColor: colorList.find(
            (i) => i.level == orderScoreProfile.sysHitGrade,
          )
            ? colorList.find((i) => i.level == orderScoreProfile.sysHitGrade)
                .color
            : '',
        }"
      >
        系统评级
        <span class="value">{{ orderScoreProfile.sysHitGrade }}</span>
        级
      </div>
      <div
        class="item"
        v-if="orderScoreProfile.finalHitGrade"
        :style="{
          backgroundColor: colorList.find(
            (i) => i.level == orderScoreProfile.finalHitGrade,
          )
            ? colorList.find((i) => i.level == orderScoreProfile.finalHitGrade)
                .color
            : '',
        }"
      >
        最终评级
        <span class="value">{{ orderScoreProfile.finalHitGrade }}</span>
        级
      </div>-->

      <div class="item arbitrage-price">
        <div>套现空间</div>
        ￥{{ detailInfo.arbitragePrice }}
      </div>

      <div v-if="detailInfo.budgetAmount && Number(detailInfo.budgetAmount) > 0" class="item budget-price">
        <div>客户首付预算</div>
        ￥{{ detailInfo.budgetAmount }}
      </div>
    </div>

    <div class="submit-btn">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-check"
        @click="submitResult(1)"
      >
        同意
      </el-button>

      <el-button
        type="danger"
        size="small"
        icon="el-icon-delete"
        @click="submitResult(2)"
      >
        拒绝
      </el-button>

      <el-button
        type="info"
        size="small"
        icon="el-icon-close"
        @click="submitResult(3)"
      >
        取消
      </el-button>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <!-- 同意 -->
      <div v-show="result == 1" class="content">
        <div class="item">
          <span>
            <span class="my-waring">审核通过</span>
          </span>
          <!-- <span class="my-waring">{{ memberGradeLog.gradeName }}</span> -->
        </div>
        <div class="item">
          <span> 请确认账期：</span>
          <span>
            <el-checkbox-group v-model="periodList">
              <el-checkbox v-for="item in periodList" :key="item" :label="item"
                >第{{ item }}期</el-checkbox
              >
            </el-checkbox-group>
          </span>
        </div>
        <div class="item">
          <span>备注：</span>
          <span>
            <el-input
              v-model="reviewPass"
              rows="5"
              type="textarea"
              placeholder="请输入备注"
            ></el-input>
          </span>
        </div>
      </div>
      <!-- 拒绝 -->
      <div v-show="result == 2" class="content">
        <div class="tips">
          审核 <span class="my-waring">拒绝</span> ，请输拒绝入原因
        </div>
        <el-input
          v-model="content"
          rows="5"
          type="textarea"
          placeholder=""
        ></el-input>
      </div>
      <!-- 取消 -->
      <div v-show="result == 3" class="content">
        <div class="tips">
          <span class="my-waring">取消</span>订单，请输入取消原因
        </div>
        <el-input
          v-model="remark"
          rows="5"
          type="textarea"
          placeholder=""
        ></el-input>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
        <el-button type="primary" @click="save" size="small">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  handleReviewPassAPI,
  handleReviewCancelAPI,
  handleReviewRefuseAPI,
} from "./api";
export default {
  name: "AuditResult",
  props: {
    orderScoreProfile: {
      type: Object,
      default: () => {},
    },
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      result: null,
      content: "",
      remark: "",
      contactList: [],
      reviewPass: "",
      colorList: [
        {
          color: "#28D576",
          level: "A",
        },
        {
          color: "#1483EA",
          level: "B",
        },
        {
          color: "#FFAC46",
          level: "C",
        },
        {
          color: "#D05252",
          level: "D",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      rate: (state) => state.audit.rate,
      periodList: (state) => state.audit.periodList,
    }),
    orderType() {
      let orderType = this.$route.query.orderType;
      return orderType == 2 || orderType == 4;
    },
  },
  mounted() {},

  methods: {
    submitResult(val) {
      let orderType = this.$route.query.orderType;
      if (
        (orderType == 2 || orderType == 4) &&
        !this.orderScoreProfile.finalHitGrade &&
        val == 1
      ) {
        this.$alert("用户评级不能为空", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
      this.$emit("result", val);
    },
    save() {
      this.dialogVisible = false;
      if (this.result == 1) {
        if (!this.reviewPass) {
          this.$alert("请填写备注!", "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
          this.dialogVisible = true;
          return;
        }
        let data = {
          orderNo: this.$route.params.id,
          prepayPeriodList: this.periodList,
          contractId: "1",
          remark: this.reviewPass,
        };
        handleReviewPassAPI(data).then(() => {
          this.$message.success("审核同意成功，即将关闭本页面...");
          setTimeout(() => {
            this.emitAwindow();
            window.close();
          }, 2000);
        });
      } else if (this.result == 2) {
        let data = {
          orderNo: this.$route.params.id,
          remark: this.content,
        };
        handleReviewRefuseAPI(data).then(() => {
          this.$message.success("拒绝成功，即将关闭本页面...");
          setTimeout(() => {
            this.emitAwindow();
            window.close();
          }, 2000);
        });
      } else if (this.result == 3) {
        let data = {
          orderNo: this.$route.params.id,
          remark: this.remark,
        };
        handleReviewCancelAPI(data).then(() => {
          this.$message.success("订单取消成功，即将关闭本页面...");
          setTimeout(() => {
            this.emitAwindow();
            window.close();
          }, 2000);
        });
      }
    },
    emitAwindow() {
      if (window.opener) {
        if (window.opener.getBpageList) {
          window.opener.getBpageList();
        } else {
          window.opener.frames[0].getBpageList();
        }
      }
    },
    closePage() {
      this.emitAwindow();
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  .score {
    display: flex;
    align-items: center;
    gap: 16px;
    
    .item {
      color: #fff;
      border-radius: 8px;
      font-size: 14px;
      padding: 8px 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }

      .value {
        font-size: 24px;
        font-weight: 600;
        margin: 0 4px;
      }
    }
  }
  
  .content {
    margin-top: 20px;
    
    .item {
      display: flex;
      margin: 15px 0;
      align-items: flex-start;
      
      & > span {
        &:first-child {
          white-space: nowrap;
          margin-right: 10px;
          color: #606266;
          font-weight: 500;
        }
      }
      
      &:nth-child(n + 2) {
        & > span {
          &:first-child {
            width: 100px;
            text-align: right;
            flex-shrink: 0;
          }
          &:last-child {
            flex: 1;
          }
        }
      }
    }
    
    .tips {
      margin: 5px 0;
      font-size: 15px;
      color: #303133;
    }
  }
  
  .submit-btn {
    display: flex;
    gap: 12px;
    align-items: center;
    
    .el-button {
      border-radius: 6px;
      padding: 10px 20px;
      font-weight: 500;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }
  
  .el-dialog {
    border-radius: 12px;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
      
      .el-textarea__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }
      
      .el-checkbox-group,
      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        
        .el-checkbox,
        .el-radio {
          margin-right: 0;
          
          .el-checkbox__label,
          .el-radio__label {
            padding-left: 8px;
          }
        }
      }
    }
    
    .el-dialog__footer {
      padding: 16px 24px;
      background: #fafbfc;
      border-top: 1px solid #f0f2f5;
      
      .el-button {
        border-radius: 6px;
        padding: 10px 20px;
        font-weight: 500;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
  
  .my-waring {
    color: #f56c6c;
    font-weight: 600;
    font-size: 18px;
  }
  
  .tit {
    margin: 10px 0;
  }
}

.space-between {
  justify-content: space-between;
}

.arbitrage-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  min-width: 140px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f56c6c 0%, #d05252 100%);
  font-weight: 500;
  
  div:first-child {
    font-size: 12px;
    opacity: 0.9;
    margin-bottom: 4px;
  }
}

.budget-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  min-width: 140px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #67c23a 0%, #47A8B4 100%);
  font-weight: 500;
  
  div:first-child {
    font-size: 12px;
    opacity: 0.9;
    margin-bottom: 4px;
  }
}
</style>
